import axios from 'axios';
import { useAuthStore } from '../Stores/useAuthStore';
import { msalInstance } from '../App'; 

export interface ServiceResponse<T> {
  items: T;
  lastPage?: number;
  page?: number;
  totalItems?: number;
}

export const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  withCredentials: false,
});

instance.interceptors.request.use(async (config) => {
  const accounts = msalInstance.getAllAccounts();
  const scope = process.env.REACT_APP_AZURE_SCOPE as string;

  if (accounts.length === 0) return config;

  try {
    const response = await msalInstance.acquireTokenSilent({
      scopes: [scope],
      account: accounts[0],
    });

    const accessToken = response.accessToken;
    useAuthStore.setState({ accessToken });
    config.headers.Authorization = `Bearer ${accessToken}`;
  } catch (error) {
    console.error('Error acquiring token silently:', error);
  }

  return config;
});